import { StyleOption } from '@/types/common';

export const STYLE_OPTIONS: StyleOption[] = [
  {
    key: 'modern',
    name: '现代简约',
    img: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=800&auto=format&fit=crop',
  },
  {
    key: 'nordic',
    name: '北欧风',
    img: 'https://images.unsplash.com/photo-1617806118233-18e1de247200?q=80&w=800&auto=format&fit=crop',
  },
  {
    key: 'industrial',
    name: '工业风',
    img: 'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?q=80&w=800&auto=format&fit=crop',
  },
  {
    key: 'chinese',
    name: '新中式',
    img: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?q=80&w=800&auto=format&fit=crop',
  },
  {
    key: 'mediterranean',
    name: '地中海',
    img: 'https://images.unsplash.com/photo-1560448204-603b3fc33ddc?q=80&w=800&auto=format&fit=crop',
  },
  {
    key: 'retro',
    name: '美式复古',
    img: 'https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?q=80&w=800&auto=format&fit=crop',
  },
  {
    key: 'luxury',
    name: '轻奢风',
    img: 'https://images.unsplash.com/photo-1617098900591-3f90928e8c54?q=80&w=800&auto=format&fit=crop',
  },
];

export const SUPPORTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const API_CONFIG = {
  GEMINI_MODEL: 'gemini-2.5-flash-image-preview',
  MAX_RETRIES: 3,
  TIMEOUT: 30000, // 30 seconds
} as const;